import type { SubscriptionEmbedData } from "../../types/SubscriptionEmbed";
import { httpGet } from "../../services/api";
import { convertKeysToCamelCase } from "../utils/convertKeysToCamelCase";

export const sdkGetSubscriptionPlans = async ({
  planGroupId,
  customerId,
  lang,
}: {
  planGroupId: string;
  customerId: string;
  lang: string;
}) => {
  const { data } = await httpGet<{ data: SubscriptionEmbedData }>(
    `subscriptions/embeds/${planGroupId}/?customer=${customerId}&lang=${lang}`
  );
  return data.action_data.embed_details.plans.map(convertKeysToCamelCase);
};
